import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { CONFIG } from 'src/config-global';

import { MainLayout } from 'src/layouts/main';
import { EstablishmentLayout } from 'src/layouts/main/establishment-layout';

import { SplashScreen } from 'src/components/loading-screen';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';

// ----------------------------------------------------------------------

const HomePage = lazy(() => import('src/pages/home'));
const EstablishmentListPage = lazy(() => import('src/pages/establishment-selected'));
const EstablishmentPage = lazy(() => import('src/pages/establishment-page'));

export function Router() {
  return useRoutes([
    {
      path: '/',
      /**
       * Skip home page
       * element: <Navigate to={CONFIG.auth.redirectPath} replace />,
       */
      element: (
        <Suspense fallback={<SplashScreen />}>
          <MainLayout>
            <HomePage />
          </MainLayout>
        </Suspense>
      ),
    },

    {
      path: "/establishment-selected/:name",
      element: (
        <Suspense fallback={<SplashScreen />}>
          <MainLayout>
            <EstablishmentListPage />
          </MainLayout>
        </Suspense>
      ),
    },

    {
      path: "/establishment-page/:id",
      element: (
        <Suspense fallback={<SplashScreen />}>
          <EstablishmentLayout>
            <EstablishmentPage />
          </EstablishmentLayout>
        </Suspense>
      ),
    },

    // Auth
    ...authRoutes,
    ...authDemoRoutes,

    // Dashboard
    ...dashboardRoutes,

    // Main
    ...mainRoutes,

    // Components
    ...componentsRoutes,

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
